{
    "yes": "áno",
    "no": "nie",
    "header.simulation_list": "Zoznam simulácií",
    "header.node_list": "Zoznam uzlov",
    "header.settings": "Používateľské nastavenia",
    "header.simulation_detail": "Simulácia",
    "header.simulation_add": "Pridať simuláciu",
    "header.simulation_add_new": "Pridať novú simuláciu",
    "header.simulation_graph": "Graf simulácie",
    "nav.menu_open": "Zobraziť",
    "nav.menu_close": "Zatvoriť",
    "nav.search": "Vyhľadávať",
    "nav.node_list": "Uzly",
    "nav.simulation_list": "Simulácie",
    "nav.settings": "Nastavenia",
    "nav.back": "Vrátiť sa",
    "sort.new": "Najnovšie",
    "sort.alph": "Abecedne",
    "sort.recent_visited": "Posledné navštívené",
    "sort.updated": "Posledné aktualizované",
    "button.add_simulation": "Pridať simuláciu",
    "button.upload_file_simulation": "Nahrať zo súboru",
    "button.create_simulation": "Vytvoriť",
    "button.create_simulation_confirm": "Dokončiť",
    "button.hide_filters": "Zrušiť filtre",
    "button.download_simulation": "Stiahnuť",
    "button.show_simulation_graph": "Zobraziť graf",
    "button.next_page": "nasledujúca strana",
    "button.previous_page": "predchadzajúca strana",
    "button.show_more": "zobraziť viac",
    "button.collapse": "skryť",
    "button.list_compact_enable": "zmeniť list na kompaktný",
    "button.list_compact_disable": "zmeniť list na detailný",
    "label.name": "Názov",
    "label.date": "Dátum",
    "label.type": "Typ",
    "label.status": "Status",
    "label.dimensionality": "Dimenzionalita",
    "label.simulation_type": "Spôsob simulovania",
    "label.iteration_count": "Počet iterácií (milióny)",
    "label.time_delta": "Časový krok",
    "label.solar_wind_speed": "Rýchlosť vetra",
    "label.dif_coef": "Difúzny koeficient",
    "label.kparkper": "Kpar/Kper",
    "label.mu_width_cos": "Kosínus šírky Mu",
    "label.language": "Jazyk",
    "label.duration": "Trvanie",
    "label.progress": "Progres",
    "status.done": "Dokončené",
    "status.pending": "V poradí",
    "status.in_progress": "Vykonáva sa",
    "status.canceled": "Zrušené",
    "status.uploaded": "Nahraté",
    "date.days_short": "d",
    "date.hours_short": "h",
    "date.minutes_short": "m",
    "date.seconds_short": "s",
    "page.simulation_list.empty": "Žiadne simulácie",
    "page.simulation_details.empty": "Simulácia nebola nájdená",
    "page.node_list.unknown": "Neznámy",
    "page.node_list.empty": "Žiadne uzly",
    "page.node_list.is_active": "Aktívny",
    "page.node_list.is_computing": "Pracuje",
    "page.node_list.last_update_time": "Posledná odozva",
    "page.simulation_new.upload_fail": "Ľutujeme, nedokázali sme načítať súbor.",
    "page.simulation_detail.unfinished_warning": "Simulácia nie je dokončená. Kompletné dáta budú dostupné po jej dokončení.",
    "page.simulation_graph.not_landscape": "Otočte obrazovku zariadenia pre lepšie zobrazenie grafu",
    "page.simulation_graph.api.download_error": "Ľutujeme, nedokázali sme získať dáta grafu.",
    "page.simulation_graph.unavailable": "Graf nebolo možné načítať",
    "page.not_found.title": "Mrzí nás to!",
    "page.not_found.description": "Nenašli sme stránku, ktorú hľadáte...",
    "notification.on_online": "Späť online.",
    "notification.on_offline": "Stratenie internetového pripojenia.",
    "api.error.offline": "Skontrolujte internetové pripojenie a skúste to znova neskôr.",
    "api.error.unsuccessful_request": "Ľutujeme, nedokázali sme sa pripojiť k serverom. Skúste to znova neskôr.",
    "api.error.invalid_request": "Ľutujeme, nedokázali sme získať požadované dáta. Kontaktujte prosím administrátora.",
    "api.error.invalid_response": "Ľutujeme, nedokázali sme získať požadované dáta. Skúste to znova neskôr.",
    "api.error.invalid_response_partial": "Ľutujeme, nedokázali sme získať niektoré z požadovaných dát. Skúste to znova neskôr.",
    "api.error.send.invalid_response": "Ľutujeme, nedokázali sme poslať vašu požiadavku. Skúste to znova neskôr."
}